class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(async () => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        
        // Get cart count
        const res = await fetch("/cart.js");
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
    
        // Update cart
        await updateCartDrawer();
    
        // Open cart drawer
        openCartDrawer();
      });
  }
}

customElements.define('product-form', ProductForm);
